import { api } from '@setplex/tria-api'
import { combine, createEvent, sample } from 'effector'
import { commit, version } from '~/app/environment'
import { model as i18n } from '~/core/i18n'
import { register } from '~/core/repository'
import { model as router } from '~/core/router'
import { model as session } from '~/entities/session'
import { entitySubscriptionsModel } from '~/entities/subscriptions'
import { formatExpirationDate } from '~/shared/helpers/date'
import { getTimezone } from './helpers'

export const init = createEvent()

const $info = combine(
  api.session.$session,
  session.$subscriberName,
  entitySubscriptionsModel.$currentSubscription,
  i18n.$t,
  (sessionData, subscriberName, currentSubscription, _t) => ({
    ...sessionData, // TODO: get rid of `content` field later
    subscriberName: subscriberName ?? sessionData?.subscriberName ?? '',
    subscription: currentSubscription?.name ?? '',
    expirationTime: formatExpirationDate(sessionData?.expirationTime),
    timezone: getTimezone(sessionData?.timezone),
    appVersion: `${version}#${commit || 'dev'}`,
  })
)

const backToSettings = createEvent()

sample({
  clock: backToSettings,
  fn: () => '/modules/settings',
  target: router.navigatePush,
})

register($info, '$settings/info/info')
register(backToSettings, 'settings/info/backToSettings')
